import Vue                     from 'vue'
import { library }             from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon }     from '@fortawesome/vue-fontawesome'
import {
  faMoneyCheckAlt as fasMoneyCheckAlt,
  faFileInvoiceDollar as fasFileInvoiceDollar,
  faUserTie as falUserTie,
  faBuilding as falBuilding,
  faArrowLeft as falArrowLeft,
  faChevronCircleRight as falChevronCircleRight,
  faChevronCircleLeft as falChevronCircleLeft
}                              from '@fortawesome/pro-light-svg-icons'
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons'

library.add(fasMoneyCheckAlt)
library.add(fasFileInvoiceDollar)
library.add(falUserTie)
library.add(falBuilding)
library.add(falArrowLeft)
library.add(falChevronCircleRight)
library.add(falChevronCircleLeft)
library.add(fasCheck)

Vue.component('font-awesome-icon', FontAwesomeIcon)
